import React from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Checkbox } from 'antd';
import WelcomeImage from '../../Components/ImagesWithElements/WelcomeImage';
import PasswordInput from '../../Components/PasswordInput';
import usePortalService from '../../services/PortalService';
import { Spin } from 'antd';

type LoginWithCodeProps = {
    setToken: (token: string) => void;
    setRole: (role: string) => void;
}

let codeEmployer = '';
export default function Registration({ setToken, setRole }: LoginWithCodeProps) {
    const {registerManager, getCompanyImage} = usePortalService();
    const navigate = useNavigate();

    const params = useParams();
    codeEmployer = params.codeEmployer as string;

    const [firstName, setFirstName] = useState('');
    const [firstNameDirty, setFirstNameDirty] = useState(false);
    const [firstNameError, setFirstNameError] = useState('Имя не может быть пустым');

    const [lastName, setLastName] = useState('');
    const [lastNameDirty, setLastNameDirty] = useState(false);
    const [lastNameError, setLastNameError] = useState('Фамилия не может быть пустой');

    const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
    const [email, setEmail] = useState('');
    const [emailDirty, setEmailDirty] = useState(false);
    const [emailError, setEmailError] = useState('Email не может быть пустым');

    const regPhone = /^\d{11}$/;
    const [phone, setPhone] = useState('');
    const [phoneDirty, setPhoneDirty] = useState(false);
    const [phoneError, setPhoneError] = useState('Телефон не может быть пустым');

    const [password, setPassword] = useState('');
    const [passwordDirty, setPasswordDirty] = useState(false);
    const [passwordError, setPasswordError] = useState('Пароль не может быть пустым');

    const [confirmPassword, setConfirmPassword] = useState('');
    const [confirmPasswordDirty, setConfirmPasswordDirty] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState('Пароль не может быть пустым');

    const [agree, setAgree] = useState(false);
    const [agreeDirty, setAgreeDirty] = useState(false)
    const [agreeError, setAgreeError] = useState('Для регистрации необходимо согласиться с политикой конфиденциальности и дать согласие на обработку персональных данных');

    const [authError, setAuthError] = useState('');
    const [sended, setSended] = useState(false);

    const firstNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value)
        if (e.target.value.length < 1) {
            setFirstNameError('Введите имя')
        } else if (e.target.value.length < 2) {
            setFirstNameError('Имя не может состоять из одного символа')
        } else {
            setFirstNameError('')
        }
    }

    const lastNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value)
        if (e.target.value.length < 1) {
            setLastNameError('Введите фамилию')
        } else if (e.target.value.length < 2) {
            setLastNameError('Фамилия не может состоять из одного символа')
        } else {
            setLastNameError('')
        }
    }

    const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
        } else {
            setEmailError('')
        }
    }

    const phoneHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhone(e.target.value)
        if (!regPhone.test(String(e.target.value).toLowerCase())) {
            setPhoneError('Некорректный номер телефона')
        } else {
            setPhoneError('')
        }
    }

    const passwordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError('Длина пароля не может быть меньше 8 символов')
        } else {
            setPasswordError('')
        }
        if (e.target.value != confirmPassword) {
            setConfirmPasswordError('Пароли не совпадают')
        }
        else {
            setConfirmPasswordError('')
        }
    }

    const confirmPasswordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value)
        if (e.target.value != password) {
            setConfirmPasswordError('Пароли не совпадают')
        }
        else {
            setConfirmPasswordError('')
        }
    }

    const agreeHandler = () => {
        if (agree) {
            setAgree(false);
            setAgreeError('Для регистрации необходимо согласиться с политикой конфиденциальности и дать согласие на обработку персональных данных')
        } else {
            setAgree(true)
            setAgreeError('')
        }
        setAgreeDirty(true)
    }

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'firstName':
                setFirstNameDirty(true)
                break;
            case 'lastName':
                setLastNameDirty(true)
                break;
            case 'email':
                setEmailDirty(true)
                break;
            case 'phone':
                setPhoneDirty(true)
                break;
            case 'password':
                setPasswordDirty(true)
                break;
            case 'confirmPassword':
                setConfirmPasswordDirty(true)
                break;
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (firstNameError || lastNameError || emailError || phoneError || passwordError || confirmPasswordError || !agree) {
            setFirstNameDirty(true)
            setLastNameDirty(true)
            setEmailDirty(true)
            setPhoneDirty(true)
            setPasswordDirty(true)
            setConfirmPasswordDirty(true)
            setAgreeDirty(true)
        } else {
            setSended(true)
            setAuthError('')
            let result;
            if (codeEmployer) {
                result = await registerManager({
                    login: email,
                    password,
                    lastName,
                    firstName,
                    phone,
                    token: codeEmployer
                });
                if (result.success && result.isRedirectToMainPage) {
                    if (result.iconProfile) {
                        setToken(result.token);
                        const icon = await getCompanyImage(result.iconProfile)
                        localStorage.setItem('iconProfile', icon);
                    }
                    navigate("/fillProfile");
                    localStorage.setItem('incompleteTours', JSON.stringify(['homeEmployer', 'vacancyEditor', 'candidates']))
                } else if (result.success) {
                    navigate("/fillProfile1");
                    localStorage.setItem('incompleteTours', JSON.stringify(['homeEmployer', 'vacancyEditor', 'candidates']))
                }
            } else {
                setAuthError('Для регистрации работодателя необходима уникальная ссылка')
            }
            if (result.success) {
                setToken(result.token);
                setRole(result.role);
                sessionStorage.setItem('email', email);
                sessionStorage.setItem('headingAlert', 'Регистрация прошла успешно!');
                navigate(0);
            } else {
                setSended(false)
                setAuthError(result.errors)
            }
        }
    }

    return (
        <div className="main-container">
            <section className="auth-sidebar d-none d-md-block">
                <WelcomeImage />
            </section>
            <div className="content" >
                <div className="auth-content">
                    <h1 style={{ marginBottom: '32px' }}> Регистрация в РТСИМ.Карьера</h1>
                    <Form onSubmit={handleSubmit}>
                        <div className="pair-input">
                            <Form.Group className="form-group first-in-pair" controlId="formFirstName">
                                <Form.Label> Имя </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='firstName'
                                    value={firstName}
                                    onBlur={blurHandler}
                                    onChange={firstNameHandler}
                                    isInvalid={!!(firstNameDirty && firstNameError)} 
                                />
                                {(firstNameDirty && firstNameError) && <p className="error-alert">{firstNameError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group second-in-pair" controlId="formLastName">
                                <Form.Label> Фамилия </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='lastName'
                                    value={lastName} 
                                    onBlur={blurHandler} 
                                    onChange={lastNameHandler}
                                    isInvalid={!!(lastNameDirty && lastNameError)}  
                                />
                                {(lastNameDirty && lastNameError) && <p className="error-alert">{lastNameError}</p>}
                            </Form.Group>
                        </div>
                        <div className="pair-input">
                            <Form.Group className="form-group first-in-pair" controlId="formEmail">
                                <Form.Label> Email </Form.Label>
                                <Form.Control 
                                    type="email" 
                                    name='email'
                                    value={email} 
                                    onBlur={blurHandler}
                                    onChange={emailHandler}
                                    isInvalid={!!(emailDirty && emailError)}  
                                />
                                {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group second-in-pair" controlId="formPhone">
                                <Form.Label> Телефон </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='phone'
                                    value={phone}
                                    onBlur={blurHandler} 
                                    onChange={phoneHandler}
                                    isInvalid={!!(phoneDirty && phoneError)}  
                                />
                                {(phoneDirty && phoneError) && <p className="error-alert">{phoneError}</p>}
                            </Form.Group>
                        </div>
                        <Form.Group className="form-group" controlId="formPassword">
                            <Form.Label> Пароль </Form.Label>
                            <PasswordInput 
                                name="password" 
                                value={password} 
                                onChange={e => passwordHandler(e)} 
                                onBlur={e => blurHandler(e)} 
                                placeholder="8+ символов"
                                isInvalid={!!(passwordDirty && passwordError)}  
                            />
                            {(passwordDirty && passwordError) && <p className="error-alert">{passwordError}</p>}
                        </Form.Group>
                        <Form.Group className="form-group" controlId="formConfirmPassword">
                            <Form.Label> Повтор пароля </Form.Label>
                            <PasswordInput 
                                name='confirmPassword'
                                value={confirmPassword} 
                                onBlur={e => blurHandler(e)} 
                                onChange={e => confirmPasswordHandler(e)}
                                isInvalid={!!(confirmPasswordDirty && confirmPasswordError)} 
                            />
                            {(confirmPasswordDirty && confirmPasswordError) && <p className="error-alert">{confirmPasswordError}</p>}
                        </Form.Group>
                        <div className="form-group">
                            <div 
                            style={{display: 'flex',
                                alignItems: 'flex-start'}}>
                                <Checkbox
                                    checked={agree}
                                    onClick={() => agreeHandler()}
                                    style={{marginRight:'8px'}}
                                />
                                <p> 
                                    Я согласен(-сна) с <Link to="/privacyPolicy" target="_blank">Политикой Конфиденциальности</Link> и даю <Link to="/personalData" target="_blank">Согласие</Link> на обработку персональных данных</p>
                                </div>
                            {(agreeDirty && agreeError) && <p className="error-alert">{agreeError}</p>}
                        </div>
                        <br />
                        {(sended) ? 
                            <Spin tip="Загрузка">
                                <div className="content" />
                            </Spin> :
                            <Button variant="primary" type="submit"  style={{width: '179px', height: '40px'}}> Зарегистрироваться </Button>
                        }
                        <p className="error-alert">{authError}</p>
                    </Form>
                </div>
            </div>
        </div>
    );
};
